<template>
  <div :class="`m-mobile m-mobile-${routeType}-page`">
    头部导航
    <mobile-nav-top></mobile-nav-top>左侧导航
    <mobile-nav-left></mobile-nav-left>
    <bs-page :filter="filter" :meta="meta" ref="refId" content-class>
      <template slot="data" slot-scope="slot">
        <li
          v-for="item in slot.data"
          :key="item.destId"
          @click="handleDetail(item)"
        >{{item.destName}}</li>
      </template>
      <template slot="empty">空数据</template>
      <template slot="paging" slot-scope="slot">
        <el-pagination
          layout="prev, pager, next"
          @size-change="pageSizeChange"
          @current-change="pageIndexChange"
          :current-page="filter.pageIndex"
          :page-size="filter.pageSize"
          :total="slot.data.totalCount"
        ></el-pagination>
      </template>
    </bs-page>
    <mobile-footer></mobile-footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routeType: "dest",
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        pageIndex: 1,
        pageSize: 1
      },
      api: null
    };
  },
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BsPage: () => import("../../components/bs-page"),
    PortalNavTop: () => import("./mobile-nav-top"),
    PortalNavLeft: () => import("./mobile-nav-left"),
    PortalFooter: () => import("./mobile-footer")
  },
  methods: {
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/mobile/dest/detail/${_module}/${_field}_detail/${item.destId}`
      });
    },
    pageSizeChange(val) {
      let that = this;
      that.filter.pageSize = val;
      this.$refs["refId"].loadData();
    },
    pageIndexChange(val) {
      let that = this;
      that.filter.pageIndex = val;
      this.$refs["refId"].loadData();
    }
  },
  created() {
    this.$menuFn.setTitle("mobile-dest-page");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-dest-page") {
        this.$menuFn.setTitle("mobile-dest-page");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "page",
        "mobile",
        true
      );
      if (this.routeWatch && contain) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style lange="sass" scoped>
</style>